import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import Hero from "../../components/Hero";
import About from "../../components/About";
import FeaturedYachts from "../../components/FeaturedYachts";
import Testimonials from "../../components/Testimonials";
import Footer from "../../components/Footer";

function HomeScreen() {
    const [user, setUser] = useState(null);
    const [isHovered, setIsHovered] = useState(false);
    const [isAdminButtonVisible, setIsAdminButtonVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const checkUserStatus = () => {
            const userInfo = localStorage.getItem("user");
            if (userInfo) {
                setUser(JSON.parse(userInfo));
            } else {
                setUser(null);
            }
        };

        // İlk yüklemede user durumunu kontrol et
        checkUserStatus();

        // loginStatusChanged event'ini dinle
        const handleLoginStatusChange = () => {
            checkUserStatus();
        };

        window.addEventListener('loginStatusChanged', handleLoginStatusChange);

        return () => {
            window.removeEventListener('loginStatusChanged', handleLoginStatusChange);
        };
    }, []);

    useEffect(() => {
        const controlAdminButton = () => {
            const heroSection = document.querySelector(".hero-section");
            if (!heroSection) return;

            const heroHeight = heroSection.offsetHeight;
            const currentScrollY = window.scrollY;

            if (
                currentScrollY > lastScrollY &&
                currentScrollY > heroHeight * 0.8
            ) {
                setIsAdminButtonVisible(false);
            } else if (currentScrollY < lastScrollY) {
                setIsAdminButtonVisible(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", controlAdminButton);
        return () => window.removeEventListener("scroll", controlAdminButton);
    }, [lastScrollY]);

    const handleAdminPanelRedirect = () => {
        window.location.href = "/admin";
    };

    return (
        <div>
            <Navbar />
            {user && user.userType === 2 && (
                <div className={`fixed top-24 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-500 ${
                    isAdminButtonVisible
                        ? "translate-y-0 opacity-100"
                        : "-translate-y-full opacity-0 pointer-events-none"
                }`}>
                    <button
                        onClick={handleAdminPanelRedirect}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        className={`bg-white/10 backdrop-blur-xl border border-white/20 text-white px-5 py-3 rounded-2xl shadow-2xl transition-all duration-300 flex items-center gap-3 font-medium text-sm overflow-hidden relative ${
                            isHovered
                                ? "bg-white/15"
                                : ""
                        }`}
                    >
                        <svg
                            className="w-5 h-5 relative z-10"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 2l2 2-2 2-2-2 2-2z"
                            />
                        </svg>
                        <span className="relative z-10">
                            Admin Paneli'ne Geç
                        </span>
                    </button>
                </div>
            )}
            <Hero />
            <About />
            <FeaturedYachts />
            <Testimonials />
            <Footer />
        </div>
    );
}

export default HomeScreen;
